import { Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { FileText } from "lucide-react";
import { issueDocsQuery, taskDocsQuery } from "@/lib/docs";
import type { ProjectData } from "@/lib/store";

/** "Docs" section on issue/task detail: documents that link here, with the quoted text. */
export function DocBackrefs({ d, entity }: { d: ProjectData; entity: { type: "issue" | "task"; id: string } }) {
  const { t } = useTranslation();
  const q = useQuery(entity.type === "issue" ? issueDocsQuery(entity.id) : taskDocsQuery(entity.id));
  const links = q.data ?? [];
  return (
    <div className="mt-4 border-t border-border pt-3">
      <div className="mb-1 text-[12px] text-muted">{t("docs.backrefs")}</div>
      {links.length === 0 && <div className="text-[12px] text-faint">{t("docs.noBackrefs")}</div>}
      <ul className="flex flex-col gap-1.5">
        {links.map((l) => (
          <li key={l.id} className="text-[12.5px]">
            <Link
              to="/$ws/doc/$id"
              params={{ ws: d.slug, id: l.doc_id }}
              search={{ link: l.target_type === "issue" ? `tern:issue/${d.project.key}-${d.issues[l.target_id]?.number ?? ""}` : `tern:task/${l.target_id}`, n: String(l.occurrence) }}
              className="flex items-center gap-1.5 hover:underline"
              title={t("docs.openInDoc")}
            >
              <FileText className="h-3.5 w-3.5 text-muted" />
              <span className="truncate font-medium">{l.doc_title}</span>
            </Link>
            <div className="truncate pl-5 text-faint">“{l.quote}”</div>
          </li>
        ))}
      </ul>
    </div>
  );
}
